import { render, staticRenderFns } from "./MoblieContentUS.vue?vue&type=template&id=484aa0ff&scoped=true&"
import script from "./MoblieContentUS.vue?vue&type=script&lang=js&"
export * from "./MoblieContentUS.vue?vue&type=script&lang=js&"
import style0 from "./MoblieContentUS.vue?vue&type=style&index=0&id=484aa0ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484aa0ff",
  null
  
)

export default component.exports